<template>
    <div v-if="transfer[0] && transfer[0].length && showBlock()"
         :class="['flight-block block',{'show': show}]">

        <!--Блок разварачивания-->
        <div @click="blockToggle('transfer')"
             class="block-toggle-bar align-center justify-between">
            <div class="block-name align-center justify-center">
                <svg width="18px" height="18px" fill="var(--white-color)" fill-opacity="0.7">
                    <use xlink:href="../../../assets/images/sprite.svg#taxi"></use>
                </svg>
                <span class="ml-8">{{ localizeList.transfer }}</span>
            </div>
            <svg width="8px" height="12px" fill="var(--white-color)" class="angle-icon">
                <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
            </svg>
        </div>
        <div v-if="show"
             class="transfer-info-wrap">
            <div v-for="(item, key) in presentTransfer"
                 :key="key"
                 class="transfer-info">
                <div v-if="showSeatPlan(item)"
                     @click="rightModalTransferInfo(item)"
                     class="more-info-link nowrap">
                    {{ localizeList.seatingPlan }}
                </div>
                <div class="transfer-group">
                    <div v-for="(item2, key2) in item"
                         v-show="showItem(item)"
                         :key="key2"
                         :style="{'order': getOrder(item2)}"
                         :class="['transfer-coontent end-checkbox', {'end-checkbox': item2.showCheckbox}]">
                        <div class="date-info">
                            <span class="day-info dark-small-bold-text mr-10 ml-6">
                                {{ getCorrectDate(item2) }}
                            </span>
                        </div>

                        <div class="place-info">
                            <div class="dark-small-text">{{ item2.code }}</div>
                        </div>

                        <div class="align-center">
                            <div class="popover-link mr-6"
                                 @mouseleave="hidePopover()"
                                 @mouseenter="showPopover(getQuotaText(item2), $event)">
                                <icon :name="getQuotaName(item2)"
                                      fill="var(--white-color)" width="16px" height="16px"/>
                            </div>
                            <div v-if="item2.transfer.length === 1" class="dark-small-text">
                                <span>{{ item2.transfer[0].label }}</span>
                                <span v-if="!item2.isChecked" class="nowrap ml-6">
                                    {{ item2.priceWillChanged }}
                                </span>
                            </div>
                            <div v-else class="align-center nowrap flex-fill">
                                <base-select :items="item2.transfer"
                                             :disabled="checkDisabled(item2)"
                                             @change="changeTransfer(key, key2, $event)"
                                             v-model="item2.transferSelectedValue"
                                             :stateTransferCheckbox="stateTransferCheckbox"
                                             :class="['transfer-class', {'disabled': checkDisabled(item2)}]"/>
                                <span v-if="!item2.isChecked" class="nowrap ml-6">
                                    {{ item2.priceWillChanged }}
                                </span>
                            </div>
                        </div>
                        <div v-if="item2.showCheckbox" class="transfer-checkbox ml-4">
                            <checkbox v-model="item2.isChecked"
                                      @change="checkedTransfer(key, key2, item2.isChecked)"
                                      :disabled="item2.isDisabled"
                                      :class="{'checked': item2.isChecked}"
                                      :label="item2.isChecked ? localizeList.included : localizeList.notIncluded"/>
                        </div>
                        <div v-else class="space ml-4"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "transfer",
        props: {
            transfer: {
                type: Array,
                default: () => []
            },
            show: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                stateTransferCheckbox: false,
            }
        },
        computed: {
            settings() {
                return this.$store.getters['getSettings']
            },
            presentTransfer() {
                return this.transfer.map(x => {
                    x = x.map(x2 => {
                        x2.priceWillChanged = !x2.isHooded ?
                            `(${this.getPlus(x2.transferSelected.allData.Cost)} ${this.correctPrice(x2.transferSelected.allData.Cost, true)} ${x2.transfer[0].rate})` :
                            `(${this.getPlus(x2.transferSelected.value)} ${this.correctPrice(x2.transferSelected.value, true)} ${x2.transfer[0].rate})`;

                        return x2;
                    });

                    return x
                })
            }
        },
        methods: {
            getQuotaName(item) {
                const quota = item.transferSelected.allData.QuotaStatus;
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quota || !quotaServices.includes(2)) {
                    return null
                }

                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = "not-aviailable"
                } else if (quota.PlacesStatus === 4) {
                    res = "request"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    res = "less"
                } else {
                    res = "aviailable"
                }
                return res
            },
            getQuotaText(item) {
                const quota = item.transferSelected.allData.QuotaStatus;
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quota || !quotaServices.includes(2)) {
                    return null
                }

                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = this.localizeList.quotaHasNoPlaces
                } else if (quota.PlacesStatus === 4) {
                    res = this.localizeList.onRequest
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                    res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                } else {
                    res = this.localizeList.available
                }
                return res
            },
            showPopover(text, e, preType = false) {
                let rect = e.target.getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height,
                    preType
                };
                this.$store.dispatch('A_SHOW_POPOVER', res);

                if (preType) {
                    document.querySelector('.popover-title').style.maxWidth = 'unset'
                } else {
                    document.querySelector('.popover-title').style.maxWidth = '320px'
                }
            },
            hidePopover() {
                this.$store.dispatch('A_HIDE_POPOVER');
                document.querySelector('.popover-title').style.maxWidth = '200px'
            },
            getCorrectDate(item) {
                let date = item.allData.BeginDateTime;
                date = date.split('T')[0].split('-').reverse().join('.');

                return date
            },
            showSeatPlan(item) {
                return item[0].allData.Details[0].IsShowTransportPlan && this.settings.UseTransferSeatChecks !== 0
            },
            rightModalTransferInfo(item) {
                this.$emit("rightModalTransferInfo", item.map(x => {
                    return {
                        ...x.allData,
                        transportKey: x.transferSelected.allData.SubCode1.Key
                    }
                }))
            },
            getOrder(item) {
                return !item.IsNotCalculate || !item.IsDeleted ? 1 : 2
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val);
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            showBlock() {
                return this.transfer.some(x => !x.isHooded);
            },
            showItem(item) {
                return !item.isHooded
            },
            checkDisabled(item) {
                return item.showCheckbox && !item.isChecked;
            },
            changeTransfer(key, key2, e) {
                this.$emit('changeTransfer', [key, key2, e])
            },
            checkedTransfer(key1, key2, value) {
                this.$emit('checkedTransfer', [key1, key2, !value])
                this.stateTransferCheckbox = true
            },
            blockToggle() {
                this.$emit("toggle", !this.show)
            },
            getPlus(numb) {
                return numb <= 0 ? "" : "+"
            },
        }
    }
</script>

<style scoped>
    .block {
        background: var(--white-color);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
        border-radius: 4px;
        margin-bottom: 12px;
        transition: all .3s;
    }

    .block .block-toggle-bar {
        border-radius: 4px;
        background: var(--primary-color);
        padding: 12px 16px;
        cursor: pointer;
    }

    .block.show .block-toggle-bar {
        border-radius: 4px 4px 0 0;
    }

    .block .block-toggle-bar .block-name span {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--white-color);
    }

    .block .block-toggle-bar .angle-icon {
        transform: rotate(-90deg);
        transition: all .2s;
    }

    .block.show .block-toggle-bar .angle-icon {
        transform: rotate(90deg);
        transition: all .2s;
    }

    /***TRANFER BLOCK***/
    .basket .transfer-info-header {
        padding: 20px 28px 0
    }

    .basket .transfer-info {
        padding: 16px 28px 20px;
    }

    .basket .transfer-info .transfer-group {
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: var(--lighten-2-color);
        border-radius: 6px;
    }

    .basket .transfer-info .transfer-group .transfer-coontent.end-checkbox {
        grid-template-columns: 100px 1fr minmax(300px, auto) minmax(160px, auto);
    }
    .basket .transfer-info .transfer-group .transfer-coontent {
        display: grid;
        align-items: center;
        grid-template-columns: 100px 1fr minmax(300px, auto);
        padding: 12px 16px 12px 12px;
    }
    .basket .transfer-info .more-info-link {
        font-size: 13px;
        line-height: 28px;
        color: var(--primary-color);
        cursor: pointer;
        transition: all .2s;
    }
    .basket .transfer-info .more-info-link:hover {
        color: #55b4f9;
    }

    .basket .transfer-info .transfer-group .transfer-coontent:not(:last-child) {
        border-bottom: 1px solid #E0E0E0;
    }

    .basket .transfer-info .transfer-group .transfer-coontent /deep/ .transfer-class.base-select .select {
        background-color: var(--white-color);
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 26px;
    }

    .basket .transfer-info .transfer-group .transfer-coontent /deep/ .disabled.transfer-class.base-select .select {
        background-color: #ddd;
    }

    .transfer-checkbox /deep/ .c-checkbox {
        justify-content: flex-end;
    }
    .transfer-checkbox /deep/ .c-checkbox #c-checkbox {
        color: #717171;
        grid-auto-flow: dense;
    }
    .transfer-checkbox /deep/ .c-checkbox #c-checkbox:before {
        grid-column-start: 2;
    }
    .transfer-checkbox /deep/ .c-checkbox #c-checkbox.active:after {
        left: unset;
        right: 2px;
    }
    .transfer-checkbox /deep/ .c-checkbox.checked #c-checkbox {
        color: var(--primary-color);
    }

</style>
